  <template >
   <div class="formPosition" v-role="'func'">
     <template>
  <v-container class="grey lighten-5">
    <v-row no-gutters>
      <v-btn style="margin-top:15px;"   fab dark color="primary" to="quando-honra">
              <v-icon dark>arrow_back</v-icon>
            </v-btn>
      <v-col >
          <h4 style="text-align:center;"> <span> Quadro de honra - Detalhes</span></h4>
<div class="text-center">

 <v-container fluid>

    <v-row>
        <v-col class="d-flex" cols="4" sm="5">
            <v-overlay :value="progresso">
            <v-progress-circular
              indeterminate
              size="64"
            ></v-progress-circular>
            </v-overlay>
        </v-col>
        <v-col class="d-flex" cols="4" sm="4">
             <label v-if="progresso">Carregando os dados , por favor aguarde...</label>

              <v-progress-circular
              v-if="progresso2"
              :size="50"
              color="green"
              indeterminate
            ></v-progress-circular>
            <span v-if="progresso2"  style="font-size:15px;">O certificado abrirá em uma nova janela...Por favor aguarde</span>

        </v-col>

    </v-row>

    <!-- <v-row>
        <v-col md="12">
           <img src="../../assets/usuario.png">
           <v-btn v-if="role === 'ROLE_FUNC'" style="margin-left:10px;margin-top:-50px;" to="/image-save"   fab dark color="primary">
                    <v-icon dark >add_a_photo</v-icon>
                </v-btn>
        </v-col>
    </v-row> -->

  </v-container>
    </div>
      </v-col>
    </v-row>

     <v-card
    class="mx-auto"
  >
    <v-list-item>
      <v-list-item-avatar>
          <img src="../../assets/usuario.png">
      </v-list-item-avatar>
      <v-list-item-content>
        <v-list-item-title class="headline">Resultado da Pesquisa</v-list-item-title>
        <v-list-item-subtitle>Informações - Estudante</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

<v-row>
  <v-col md="6">
    <v-card-text>
      <strong> Dados Pessoais</strong>
       <v-btn   :disabled="progresso"    v-if="instit ===((this.estudante_dados.length)?(this.estudante_dados[0].instituicao):'') "     color="primary" text  @click="editItem()"><v-icon large color="primary" >edit</v-icon></v-btn>

    </v-card-text>
    <hr>
    <v-row>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Nome:{{(editItemEstudante !== null)?(this.editItemEstudante.nome):''}}</v-chip>
     </v-col>
     <v-col md="6">
          <v-chip color="pink" style="margin:4px;color:white">Matricula:{{(editItemEstudante !== null)?(editItemEstudante.idMAtricula):''}}</v-chip>
     </v-col>
    </v-row>
    <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Curso:<strong>{{(editItemEstudante !== null)?(editItemEstudante.curso):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">Classe:<strong>{{(editItemEstudante !== null)?(editItemEstudante.classe):''}}</strong></v-chip>
     </v-col>
    </v-row>
     <v-row>
     <v-col md="6">
          <v-chip style="margin:4px">Anolectivo :<strong>{{(editItemEstudante !== null)?(editItemEstudante.anoLectivo):''}}</strong></v-chip>
     </v-col>
     <v-col md="6">
          <v-chip style="margin:4px">Trimestre:<strong>{{(editItemEstudante !== null)?(editItemEstudante.trimestre):''}}</strong></v-chip>
     </v-col>
    </v-row>

     <v-row>
     <v-col md="6">
          <!-- <v-chip style="margin:4px">Filho de :<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedopai):''}}</strong></v-chip> -->
     </v-col>
     <v-col md="6">
          <!-- <v-chip style="margin:4px">e De:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].nomedamae):''}}</strong></v-chip> -->
     </v-col>
    </v-row>

     <v-row>
     <v-col md="12">
          <!-- <v-chip style="margin:4px">Contacto:<strong>{{(this.estudante_dados.length)?(this.estudante_dados[0].telefone):''}}</strong></v-chip> -->
     </v-col>

    </v-row>
    <!-- <v-row>

        <v-col>

            <v-col md="12">
        <v-chip
              color="pink" style="margin:4px;color:white"
            >
              Instituição Inscrito : {{(this.estudante_dados.length)?(this.estudante_dados[0].instituicao):''}}
            </v-chip>
    </v-col>

        </v-col>

    </v-row> -->

    <hr>
  </v-col>
  <v-col md="6">
    <v-card-text>
      <v-row>
        <v-col md="6"><strong> {{titulo}}</strong></v-col>
        <v-col md="6">
          <!-- <v-tooltip bottom>
          <template v-slot:activator="{ on, attrs }">
            <v-btn
            color="#006699"
            style="color:white;"
              v-bind="attrs"
              v-on="on"
              v-if="iskilamba && (instituicao_id === 1 || instituicao_id === 5) && estudante_dados.length"
              @click="ShowAlterarProcesso()"
            >
              Alterar Nº Processo
            </v-btn>
          </template>
          <span>Função de mudança de número de Processo ( Esta função é temporária )</span>
        </v-tooltip> -->
        </v-col>
      </v-row>
      
    </v-card-text>
    <hr>

    <v-data-table
            :headers="headers"
            :items="this.estudante_dados"
          >
          <template v-slot:item.ord="{ item }">
              <span>{{(estudante_dados.indexOf(item))+1}}</span>
            </template>
       </v-data-table>
       <hr>
       <v-row>
              <v-col md="1"></v-col>
              <v-col md="3">
                   <v-chip>Somatório: {{somatorio}}</v-chip>
              </v-col>
              <v-col md="3">
                   <v-chip>Nº discip: {{Numero_disciplinas}}</v-chip>
              </v-col>
              <v-col md="4">
                   <v-chip color="primary">Média Final: {{somaNotas}}</v-chip>
              </v-col>
            </v-row>

  </v-col>

</v-row>
  </v-card>

  </v-container>
 <v-dialog v-model="formUpdateEstudante" max-width="800px">

            <v-card>

<v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
              <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col  cols="12" md="4">

<v-btn text    @click="close"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

     <v-col cols="12" md="7">  <!--  form titlte section   {{ formTitle }}-->
       </v-col>

      <v-col  cols="12" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="save"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>

  </v-row>

                  </v-toolbar>

              </template>
 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nome"
                        label="Nome"
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                      required
                        :rules="ruleBI"
                        v-model="editedItem.bi"
                        :label="descricao"
                        v-mask="mascara"
                      ></v-text-field>

                    </v-col>
                    <v-col cols="12" md="2">
                      <v-switch  @change="outroDoc()"></v-switch>
                    </v-col>

 <v-col cols="12" md="3">

   <template>

  <v-menu
    ref="menubi"
    v-model="menubi"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.dataemissaobi"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de emissâo do BI"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      max="2025-12-31"
      min="1950-01-01"
      v-model="datebi"
      @change="saveDatebi"
    ></v-date-picker>
  </v-menu>
  </template>
</v-col>

 <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-if="false"
                        v-model="editedItem.pkPessoa"
                        label="chave primaria auto increemente"
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>

                    <v-col cols="12" md="4">

                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedopai"

                        label="Filho de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedamae"

                        label=" e de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                   <template>

  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.datanascimento"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de nascimento"
        prepend-icon="event"
        readonly
        v-on="on"
      ></v-text-field>
  </template>
    <v-date-picker
      ref="picker"

      v-model="date"
     max="2006-12-31"
      min="1950-01-01"
      @change="saveDate"
    ></v-date-picker>
  </v-menu>
    </template>

                    </v-col>

                  </v-row>

                   <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="proviSelectedForComb"
                        :items="provincias"
                        item-value="idProvicia"
                        item-text="descricao"
                          @change="loadMunicipioComb"
                          @click="loadMunicipioComb"

                        chips
                        label="Natural de:"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="municSelectedForComb"
                        :items="municipiosFiltered"
                        item-value="idMunicipio"
                        item-text="descricao"
                        chips
                        label="Municipio"
                      ></v-combobox>
                    </v-col>
                     <v-col cols="12" md="4">
                      <v-combobox
                        v-model="editedItem.sexo"
                        :rules="ruleRequired"
                        item-value="idSexo"
                        item-text="descricao"
                        :items="dropdowSexo"
                        chips
                        label="Sexo"
                      ></v-combobox>
                    </v-col>

                  </v-row>
                   <v-row>

<v-col cols="12" md="4">
                      <v-text-field
                      v-model="editedItem.telefone"

                       label="Telefone">
                       </v-text-field>
                  </v-col>

      </v-row>

                </v-container>
              </v-card-text>

        </v-form>
            </v-card>
 </v-dialog>


<!-- ==================================DIALOGO KILAMBA ================================================== -->

 <v-dialog v-model="formUpdateEstudanteKilamba" max-width="800px">

            <v-card>

<v-overlay :value="overlay">
      <v-progress-circular
        indeterminate
        size="64"
      ></v-progress-circular>
    </v-overlay>
              <template >

                  <v-toolbar color="grey lighten-2">

             <v-row>
                    <v-col  cols="12" md="4">

<v-btn text    @click="closeKilamba"><v-icon large color="primary" >clear</v-icon></v-btn>

    </v-col>

     <v-col cols="12" md="7">  <!--  form titlte section   {{ formTitle }}-->
       </v-col>

      <v-col  cols="12" md="1">
     <v-btn   :disabled="!valid"           color="primary" text  @click="ActualizarProcessoKilamba()"><v-icon large color="primary" >send</v-icon></v-btn>
   </v-col>

  </v-row>

                  </v-toolbar>

              </template>
 <v-form
    ref="form"
    v-model="valid"
    lazy-validation
  >

              <v-card-text>

                <v-container  >

<div   v-if="$store.state.hasMessage" :class="$store.state.classMessage" >{{$store.state.textMessage}}</div>

                  <v-row>
                    <v-col  cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nome"
                        label="Nome"
                        disabled
                      ></v-text-field>
                    </v-col>

                    <v-col cols="12" md="3">
                      <v-text-field
                      required
                        :rules="ruleBI"
                        v-model="editedItem.bi"
                        :label="descricao"
                        v-mask="mascara"
                        disabled
                      ></v-text-field>

                    </v-col>
                    

 <v-col cols="12" md="3">

   <template>

  <v-menu
    ref="menubi"
    v-model="menubi"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    full-width
    min-width="290px"
    disabled
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.dataemissaobi"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de emissâo do BI"
        prepend-icon="event"
        disabled
        v-on="on"
      ></v-text-field>
    </template>
    <v-date-picker
      ref="picker"
      max="2025-12-31"
      min="1950-01-01"
      disabled
      v-model="datebi"
      @change="saveDatebi"
    ></v-date-picker>
  </v-menu>
  </template>
</v-col>

 <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-if="false"
                        v-model="editedItem.pkPessoa"
                        label="chave primaria auto increemente"
                        disabled
                      ></v-text-field>
                    </v-col>
                  </v-row>

                  <v-row>

                    <v-col cols="12" md="4">

                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedopai"
                        disabled
                        label="Filho de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-text-field
                        :rules="ruleTextRequired"
                        v-model="editedItem.nomedamae"
                        disabled
                        label=" e de:"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12" md="4">
                   <template>

  <v-menu
    ref="menu"
    v-model="menu"
    :close-on-content-click="false"
    transition="scale-transition"
    offset-y
    disabled
    full-width
    min-width="290px"
  >
    <template v-slot:activator="{ on }">
      <v-text-field

        v-model="editedItem.datanascimento"
        :rules="[v => !!v || 'Campo obrigatorio!']"
        label="Data de nascimento"
        prepend-icon="event"
        disabled
        v-on="on"
      ></v-text-field>
  </template>
    <v-date-picker
      ref="picker"
      disabled
      v-model="date"
     max="2006-12-31"
      min="1950-01-01"
      @change="saveDate"
    ></v-date-picker>
  </v-menu>
    </template>

                    </v-col>

                  </v-row>

                   <v-row>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="proviSelectedForComb"
                        :items="provincias"
                        item-value="idProvicia"
                        item-text="descricao"
                          @change="loadMunicipioComb"
                          @click="loadMunicipioComb"
                        disabled
                        chips
                        label="Natural de:"
                      ></v-combobox>
                    </v-col>
                    <v-col cols="12" md="4">
                      <v-combobox
                        :rules="ruleRequired"
                        v-model="municSelectedForComb"
                        :items="municipiosFiltered"
                        item-value="idMunicipio"
                        item-text="descricao"
                        chips
                        disabled
                        label="Municipio"
                      ></v-combobox>
                    </v-col>
                     <v-col cols="12" md="4">
                      <v-combobox
                        v-model="editedItem.sexo"
                        :rules="ruleRequired"
                        item-value="idSexo"
                        item-text="descricao"
                        :items="dropdowSexo"
                        chips
                        disabled
                        label="Sexo"
                      ></v-combobox>
                    </v-col>

                  </v-row>
                   <v-row>

<v-col cols="12" md="6">
                      <v-text-field
                      v-model="editedItem.telefone"
                       disabled
                       label="Telefone">
                       </v-text-field>
                  </v-col>
                  <v-col cols="12" md="6">
                      <v-text-field
                      v-model="editedItem.idMatricula"
                       label="Número de Processo">
                       </v-text-field>
                  </v-col>

      </v-row>

                </v-container>
              </v-card-text>

        </v-form>
            </v-card>
 </v-dialog>


<!--=========================================FIM DIALOGO ================================================== -->


 <v-dialog
      v-model="dialog"
      max-width="410"
    >
      <v-card>
        <v-card-title class="headline"><v-icon color="blue">info</v-icon>  Alerta</v-card-title>

        <v-card-text>
          Ao efectuar a Operação , <strong>não será possivel</strong> inverter!
        </v-card-text>

        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn
            color="red darken-1"
            text
            @click="dialog = false"
          >
            Cancelar
          </v-btn>

          <v-btn
            color="green darken-1"
            text
            @click="Insert_UpdateTransitacao()"
          >
            Continuar
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </template>
   </div>
</template>

<script>
import axios from '../../plugins/axios'
import { mask } from 'vue-the-mask'
const ls = require('local-storage')
export default {
  directives: { mask },
  data: () => ({
    formUpdateEstudante: false,
    formUpdateEstudanteKilamba: false,
    dropdowSexo: [
      { idSexo: 'M', descricao: 'Masculino' },
      { idSexo: 'F', descricao: 'Femenino' }
    ],
    select1: null,
    pesquisa_parameto: null,
    estudante_dados: [],
    matriculaExistenteResult: null,
    idMatricula: null,
    matricula_actual: '',
    msg_pesquisa: true,
    pesquisa: '',
    estudante: true,
    dialog: false,
    progresso: false,
    progresso2: false,
    Pessoas: [],
    titulo: 'Historico Acadedémico',
    progress: false,
    Pessoas_filtro: [],
    componente: [],
    componente2: [],
    componente3: [],
    componente4: [],
    editItemEstudante:null,
    ruleRequired: [value => !!value || 'campo obrigatorio'],
    ruleTextRequired: [
      value => !!value || 'campo obrigatório.',
      value =>
        (value || '').length <= 50 || 'O máximo número de carácters atigidos',

      value => (value || '').length > 3 || 'carácteres insuficientes',
      value => {
        const pattern = /(([{;=+~_!@#$%^&*()/,.?":{}|<>},{0-9}]))$/
        return !pattern.test(value) || 'Invalido.'
      }
    ],
    ruleBI: [

      value => value.length === 16 || 'Minimo de caracteres exigido( 16 ).'
    ],
    ruleEmailRequired: [
      //  value => !!value || 'Required.',
      value => value.length <= 50 || 'O máximo número de carácters atigidos',
      value => {
        const pattern = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
        return pattern.test(value) || 'Invalid e-mail.'
      }
    ],
    items1: [
      'Aluno',
      'Funcionário'
    ],
    items2: [
      'Nome',
      'Bilhete de Identidade',
      'Número de Matricula'
    ],
    ano: [
      '2017',
      '2018',
      '2019',
      '2020'
    ],
    headers: [
       { text: 'Ord.', value: 'ord' },
      { text: 'Disciplina', value: 'desc_disc' },
      { text: 'Nota', value: 'MD' },
    ],

    headersf: [
      { text: 'Ano de Admissão ', value: 'descricao_curso' },
      { text: 'Função', value: 'idAno_Academico' }
    ],
    overlay: false,
    datebi: null,
    date: null,
    iskilamba: false,
    descricao: 'Nº do Bi',
    valid: true,
    menu: false,
    menubi: false,
    habilitaBi: false,
    turmasAll: [],
    mascara: '#########-AA-###',
    resultAlteracao: null,
    turmasAllAno: [],
    turmasFiltered: [],
    municipiosAll: [],
    instituicao_id: ls.get('i_id'),
    cor: '',
    municipiosFiltered: [],
    provincias: [],
    msg: '',
    editedIndex: -1,
    municSelectedForComb: null,
    proviSelectedForComb: null,
    editedItem: {

      pkPessoa: 0,
      bi: null,
      idPessoa: '',
      idMAtricula: '',
      idMatricula: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: null,
      ResidenteEm: 1,
      instituicao: null,
      instituicaodescricao: '',
      curso: null,
      turma: null,
      resultado: '',
      fkTurma: '',
      pkInscricao_na_turma: '',
      pkTurma: 0,
      idano_academico: 0,
      anoLectivo: ''
    },
    defaultItem: {
      pkPessoa: 0,
      idPessoa: '',
      bi: '',
      idMunicipio: null,
      idPerfil: null,
      nome: '',
      morada: '',
      telefone: '',
      autor: '',
      datanascimento: '',
      data_: '',
      status_2: '',
      email: '',
      sexo: '',
      nomedopai: '',
      nomedamae: '',
      dataemissaobi: '',
      ResidenteEm: '',
      instituicao: '',
      instituicaodescricao: '',
      curso: null,
      turma: null,
      anoLectivo: ''
    }

  }),

  computed: {

    idclasse () {
      return this.$store.state.idclasse
    },
    computeddatanascimento () {
      return this.editedItem.datanascimento ? moment(this.editedItem.datanascimento).format('dddd, MMMM Do YYYY') : ''
    },
    computedDateFormattedDatefns () {
      return this.date ? format(this.date, 'dddd, MMMM Do YYYY') : ''
    },
    textMessage () {
      return this.$store.state.textMessage
    },
    classMessage () {
      return this.$store.state.classMessage
    },
    hasMessage () {
      return this.$store.state.hasMessage
    },
    role () {
      return ls.get('role')
    },
    anolectivo () {
      return ls.get('anolectivo')
    },

    somatorio (){
      let soma = 0;
       this.estudante_dados.forEach(element => {
           soma += parseInt(element.MD)
       });

       return soma
    },

    Numero_disciplinas (){
       return this.estudante_dados.length
    },

    somaNotas () {
       let soma = 0;
       this.estudante_dados.forEach(element => {
           soma += parseInt(element.MD)
       });

       return ((soma)/this.estudante_dados.length).toFixed(2);
    }

  },
  watch: {
    menu (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    menubi (val) {
      val && setTimeout(() => (this.$refs.picker.activePicker = 'YEAR'))
    },
    estudantes () {
      this.isLoading = false
      this.$store.state.isloading = false
    },
    dialog (val) {
      val || this.close()
    }
  },
  created () {
    console.log( this.$store.state.objaluno);
    this.editItemEstudante = this.$store.state.objaluno
    // check if classe has been selected otherwise send back to painel to select
     this.Pesquisar()
    // this.initializeCursos()
    // this.initializeturmasAll(this.idclasse)
    // this.initializeMunicipiosAll()
    // this.initializeProvincias()
    // this.instit= ls.get('instituicaodescricao')
    // if (window.location.host.includes('localhost')) {
    //   this.iskilamba = true
    // } else if (window.location.host.includes('eftsk')) {
    //   this.iskilamba = true
    // } else if (window.location.host.includes('eftsl')) {
    //   this.iskilamba = false
    // }
  },
  methods: {
    teste () {
      console.log(this.estudante_dados)
    },
    async initializeCursos () {
      try {
        this.isLoading = true
        this.cursos = await axios
          .get('/cursoFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },

    async initializeturmasAll (idclasse) {
      try {
        this.overlay = true
        this.turmasAll = await axios
          .get('/turmaFindAll/' + idclasse)
          .then(res => res.data)
        this.overlay = false
      } catch (error) {
        this.overlay = false

        this.text = error
        this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
      }
    },
    outroDoc () {
      if (this.descricao === 'Outro Doc.') {
        this.descricao = 'Nº do Bi'
      } else {
        this.descricao = 'Outro Doc.'
      }
    },

    loadTurmaComb (curso) { // setTimeout(() => { this.editedItem.turma=undefined }, 0)
      this.turmasFiltered = this.turmasAll.filter(t => t.idCurso === curso.idCurso)
      console.log(this.turmasAll)
      this.$nextTick(() => { this.editedItem.turma = undefined })
    },
    loadMunicipioComb (provincia) {
      this.$nextTick(() => { this.municSelectedForComb = undefined })
      // eslint-disable-next-line no-return-assign
      return this.municipiosFiltered = this.municipiosAll.filter(municipio => municipio.idProvincia === provincia.idProvincia)
    },
    async initializeMunicipiosAll () {
      try {
        this.isLoading = true
        this.municipiosAll = await axios
          .get('/municipioFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },
    async initializeProvincias () {
      try {
        this.isLoading = true
        this.provincias = await axios
          .get('/provinciaFindAll')
          .then(res => res.data)
      } catch (error) {
        this.isLoading = false

        this.text = error
      }
    },

    async  Pesquisar () {
      if (this.$store.state.objaluno !== null) {
        try {
          this.progresso = true
          this.estudante_dados = await axios
            .post('/obter-dados-pauta',this.$store.state.objaluno)
            .then(res => res.data)
          this.progresso = false
          if (!this.estudante_dados.length) { this.msg_pesquisa = false } else { this.msg_pesquisa = true }
        } catch (error) {
          this.progresso = false
        }
      } else {
        this.progresso = false
      }
    },

    async  show_dialogo_transitacao () {
      this.dialog = true
    },

    ImprimirCertificado (item) {
      this.$store.state.objaluno = item
      this.$router.push('preparar-certificado-notas-PesquisaGeral')
    },
    convertDate (dateString) {
      var p = dateString.split('-')
      // eslint-disable-next-line standard/array-bracket-even-spacing
      return [p[2], p[1], p[0] ].join('/')
    },
    saveDatebi (datebi) {
      this.$refs.menubi.save(datebi)
      this.editedItem.dataemissaobi = datebi

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      // this.datebi = new Date(date).toISOString().substr(0, 10)
    },

    ShowAlterarProcesso () {
       let item = this.estudante_dados[0]

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
        this.editedItem = Object.assign({}, item)
        this.matricula_actual = this.editedItem.idMatricula
      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      //===Faz a verificação se a instituição é kilamba ou não
      //==Caso seja , abre apenas o dialogo do kilamba
      if(this.iskilamba && (this.instituicao_id === 1 || this.instituicao_id === 5)){
        this.formUpdateEstudanteKilamba = true
      }

    },

    editItem () {
      /* this.editedIndex = this.estudantes.indexOf(item)
      this.editedItem = Object.assign({}, item) */
      let item = this.estudante_dados[0]

      // let v=  Object.assign({},  this.municipios[5]);
      try {
        // prara trazer valores default na combo
        // procura na collecao ja carregada
        this.municSelectedForComb = this.municipiosAll.filter(mun => mun.idMunicipio === item.idMunicipio)
        // seta o valor encontrado
        this.municSelectedForComb = this.municSelectedForComb[0]

        this.proviSelectedForComb = this.provincias.filter(
          prov => prov.idProvincia === this.municSelectedForComb.idProvincia
        )

        this.proviSelectedForComb = this.proviSelectedForComb[0]
        this.editedItem = Object.assign({}, item)
        this.matricula_actual = this.editedItem.idMatricula
        console.log(this.editedItem);
        console.log(this.editedItem.sexo.idSexo == undefined);

      } catch (error) {
        this.$store.dispatch('textMessage', { 'msg': error, 'classMessage': 'msgError', 'timeout': 3000 })
      }

      //===Faz a verificação se a instituição é kilamba ou não
      //==Caso seja , abre apenas o dialogo do kilamba
       
         this.formUpdateEstudante = true

     
    },
    saveDate (date) {
      this.$refs.menu.save(date)
      this.editedItem.datanascimento = date

      // this.date = new Date(date).toLocaleDateString(['pt-BR'], { day: '2-digit', month: 'long', year: 'numeric' })
      this.date = new Date(date).toISOString().substr(0, 10)
    },
    close () {
        this.formUpdateEstudante = false
      this.$refs.form.reset()
    },

    closeKilamba (){
      if(this.iskilamba && (this.instituicao_id === 1 || this.instituicao_id === 5))
         this.formUpdateEstudanteKilamba = false
      this.$refs.form.reset()
    },
    async save () {
      if (this.$refs.form.validate()) {
        this.overlay = true
        const ls = require('local-storage')
        var params = {
          pkPessoa: this.editedItem.pkPessoa,
          idPEssoa: this.editedItem.bi,
          idMunicipio: this.municSelectedForComb.idMunicipio,
          idPerfil: 1,
          nome: this.editedItem.nome,
          morada: this.editedItem.morada,
          telefone: this.editedItem.telefone,
          autor: ls.get('idPessoa'),
          datanascimento: this.editedItem.datanascimento,
          data_: this.editedItem.data_,
          status_2: this.editedItem.status_2,
          email: this.editedItem.email,
          sexo:  (this.editedItem.sexo.idSexo == undefined) ? this.editedItem.sexo : this.editedItem.sexo.idSexo,
          nomedopai: this.editedItem.nomedopai,
          nomedamae: this.editedItem.nomedamae,
          dataemissaobi: this.editedItem.dataemissaobi,
          bi: this.editedItem.bi,
          ResidenteEm: 1,
          instituicao: ls.get('i_id'),
          instituicaodescricao: this.editedItem.instituicaodescricao,
          curso: this.editedItem.curso,
          turma: this.editedItem.turma,
          anolectivo: ls.get('anolectivo'),
          idanolectivo: ls.get('idanolectivo'),
          idanoacademico: this.idclasse
        }
        try {
          let msg = await axios
            .post('/estudanteInsertOrUpdate', params)
            .then(res => res.data)
          // this.text = msg[1].insertId
          this.text = msg
          // this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 8000 })

          try {
            if (msg === 'Inserção ou Actualização feita com sucesso') {
              this.text = ' gravado(s) com sucesso'
              this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgSucess', 'timeout': 2000 })
              this.estudante_dados[0].nome = this.editedItem.nome
              this.estudante_dados[0].telefone = this.editedItem.telefone
              this.estudante_dados[0].nomedopai = this.editedItem.nomedopai
              this.estudante_dados[0].nomedamae = this.editedItem.nomedamae
              this.estudante_dados[0].datanascimento = this.editedItem.datanascimento
              this.estudante_dados[0].dataemissaobi = this.editedItem.dataemissaobi
              this.estudante_dados[0].bi = this.editedItem.bi
              this.estudante_dados[0].sexo =  (this.editedItem.sexo.idSexo == undefined) ? this.editedItem.sexo : this.editedItem.sexo.idSexo
              this.estudante_dados[0].municipio = this.editedItem.municipio
              this.estudante_dados[0].provincia = this.editedItem.provincia
            }
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) {}
          try {
            this.text = msg.message.sqlMessage
            this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
          } catch (error) {}
          this.progresso = false
        } catch (error) {
          this.isLoading = false
          this.progresso = false
          this.text = error.message
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } finally {
          this.overlay = false
        }
        if (this.msg === 'Número de Bi ja existente');
        else {
          this.editedItem.nome = ''
          this.editedItem.nomedopai = ''
          this.editedItem.nomedamae = ''
          this.editedItem.datanascimento = ''
          this.editedItem.dataemissaobi = ''
          this.editedItem.bi = ''
          this.editedItem.sexo = ''
          this.editedItem.telefone = ''
          this.editedItem.municipio = ''
          this.editedItem.provincia = ''
          this.$refs.form.resetValidation()
          if (this.editedItem.pkPessoa) {
            this.editedItem.pkPessoa = null
            setTimeout(() => {
              this.close()
            }, 1000)
          }
        }
      }
    },

  async ActualizarProcessoKilamba (){

     this.verificaNProcessoExistente(this.editedItem.idMatricula).then(()=>{
         if(this.matriculaExistenteResult !== null && this.matriculaExistenteResult.length === 0){
           this.ActualizaNumeroProcesso().then(()=>{
               if(this.resultAlteracao.affectedRows >= 0){
                  this.$store.dispatch('textMessage', { 'msg': 'O número de processo alterado com sucesso', 'classMessage': 'msgSucess', 'timeout': 3000 })
                  this.estudante_dados[0].idMatricula = this.editedItem.idMatricula
               }
           });
         }else{
           this.$store.dispatch('textMessage', { 'msg': 'O número de processo fornecido esta sendo usado por um outro estudante', 'classMessage': 'msgError', 'timeout': 3000 })
         }
     })

  },

  async verificaNProcessoExistente (processo){
      try {
          this.overlay = true
          this.matriculaExistenteResult = await axios
            .get('/verificaNProcessoExistente/'+ processo)
            .then(res => res.data)
          this.overlay = false
           
        } catch (error) {
          this.overlay = false

          this.text = error
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 3000 })
        }
  },

  async ActualizaNumeroProcesso (){


        var params = {
          matricula_actual: this.matricula_actual,
          matricula_nova: this.editedItem.idMatricula,
          anolectivo: this.anolectivo
         
        }
        try {
          this.overlay = true
          this.resultAlteracao = await axios
            .post('/ActualizarNumeroProcessoKilamba', params)
            .then(res => res.data)
          this.overlay = false
        } catch (error) {
          this.overlay = false

          this.text = error.message
          this.$store.dispatch('textMessage', { 'msg': this.text, 'classMessage': 'msgError', 'timeout': 8000 })
        } 
    

  },

    async Insert_UpdateTransitacao () {
      /* let params =
        {
          idMatricula: this.estudante_dados[0].idMatricula,
          anoLectivo: this.estudante_dados[0].anoLectivo,
          idAno_Academico: this.estudante_dados[0].idAno_Academico,
          fkPessoa: this.estudante_dados[0].pkPessoa
        } */
    }

  }

}

</script>
